import {Visible} from './visible'
export class ApiPagination  {
    init () {
        let buttonClickHandler = function (event) {
            event.preventDefault();
            let url = $(this).attr('href');

            if (url) {
                $.ajax({
                    type: 'POST',
                    url
                })
                .success(function(resp){
                    let html = resp.html;
                    let pagination = resp.pagination;

                    // window.history.pushState({}, '', url);

                    $('html, body').animate({scrollTop:0}, 500);
                    $('.api-pagination').replaceWith(pagination);
                    $('.result-wrapper').replaceWith(html);
                })
                .error(function() {
                    window.location = url; // fallback in case of ajax error
                })
                .always(function () {
                    // Rebind click event and Visible plugin
                    $('body').find('.api-pagination .page-item .page-link').off('click', buttonClickHandler).on('click', buttonClickHandler)
                    setTimeout(() => {
                        (new Visible).init()
                    }, 550)
                })
            }
        }

        $('body').find('.api-pagination .page-item .page-link').click(buttonClickHandler)
    }
}